import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PostEngager {
  engagement_id: string;
  post_url: string;
  engager_name: string | null;
  engager_linkedin_url: string | null;
  engager_title: string | null;
  engager_company: string | null;
  engagement_type: string;
  comment_text: string | null;
  engagement_date: string | null;
  is_top_account: boolean;
  poster_name: string | null;
}

export function usePostEngagers(postUrl: string | null) {
  return useQuery({
    queryKey: ['social-post-engagers', postUrl],
    queryFn: async (): Promise<PostEngager[]> => {
      if (!postUrl) return [];

      const { data, error } = await (supabase as any)
        .from('v_social_post_engagers')
        .select('*')
        .eq('post_url', postUrl)
        .order('is_top_account', { ascending: false })
        .order('engagement_date', { ascending: false });

      if (error) throw error;
      return (data || []) as PostEngager[];
    },
    enabled: !!postUrl,
  });
}
